import Image from "next/image";
import { PaymentLogo } from "@/app/lib/features/footer/footer.types";

interface FooterPaymentProps {
  logos: PaymentLogo[];
}

const FooterPayment = ({ logos }: FooterPaymentProps) => {
  if (!logos || logos.length === 0) return null;

  // API'dan tek bir büyük image geliyor
  const mainLogo = logos[0];

  return (
    <div className="space-y-1 lg:space-y-2 mt-4">
      <div className="flex justify-center">
        <div className="text-left space-y-4">
          <Image
            src={mainLogo.image}
            alt={mainLogo.name || "Kabul Edilen Kartlar"}
            width={1007}
            height={36}
            className="object-contain max-w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default FooterPayment;
